module.exports = __webpack_public_path__ + "static/img/best_original_screenplay_01.4e216ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/best_original_screenplay_01.jpg
// module id = 93
// module chunks = 0